const scrollToTop = document.getElementById('scroll-to-top');
if (scrollToTop) {
    scrollToTop.addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
}
